enum TrimsOrderedBy {
    Alphabetical = 0,
    PriceAscending = 1,
    PriceDescending = 2,
}
export default TrimsOrderedBy;
